export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "markup.worker.3ca2cced23fbd5b03dc4.worker.js");
}
